import { useTranslate } from 'sbx-crm-menu-ui';
import { Controller, UseFormSetValue } from 'react-hook-form';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';

interface DynamicInputListProps {
    label: string;
    placeholder: string;
    control: any;
    name: string;
    classNameLabel: string;
    itemList: string[];
    setValue: UseFormSetValue<any>
    inputValue: string;
    setInputValue: (value: string) => void;
}

const DynamicInputList: React.FC<DynamicInputListProps> = ({
                                                               label,
                                                               placeholder,
                                                               control,
                                                               name,
                                                               classNameLabel,
                                                               itemList,
                                                               setValue,
                                                               inputValue,
                                                               setInputValue,
                                                           }) => {
    const { t: common } = useTranslate('common');

    const handleAddItem = () => {
        if (inputValue.trim() === '') return;
        setValue(name, [...(itemList ?? []), inputValue]);
        setInputValue('');
    };

    const handleRemoveItem = (itemToRemove: string) => {
        setValue(name, itemList.filter((item) => item !== itemToRemove));
    };

    return (
        <>
            <Controller
                name={name}
                control={control}
                render={() => (
                    <div className="grid gap-1 items-center mb-5">
                        <label className={classNameLabel}>{label}</label>
                        <div className="flex gap-2">
                            <input
                                type="text"
                                autoComplete="off"
                                value={inputValue}
                                className="py-2 px-4 w-full rounded border border-gray-400 outline-none resize-none"
                                placeholder={placeholder}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter') {
                                        event.preventDefault();
                                        handleAddItem();
                                    }
                                }}
                                onChange={(event) => {
                                    setInputValue(event.target.value);
                                }}
                            />
                            <div className="w-20">
                                <button
                                    className="flex btn btn-sm h-full items-center"
                                    type="button"
                                    onClick={handleAddItem}
                                >
                                    + {common('add')}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            />
            {itemList && itemList.length > 0 ? (
                <div className="flex flex-wrap gap-3 my-2">
                    {itemList.map((item, index) => (
                        <div
                            key={index}
                            className="bg-white shadow p-2 border border-gray-400 rounded flex gap-4"
                        >
                            <p className="text-sm">{item}</p>
                            <span
                                className="cursor-pointer text-red-400 w-5 h-5 flex justify-center items-center"
                                onClick={() => handleRemoveItem(item)}
                            >
                <FontAwesomeIcon icon={faTimesCircle as any} />
              </span>
                        </div>
                    ))}
                </div>
            ) : (
                <p className="text-gray-300">{common('no_results')}</p>
            )}
        </>
    );
};

export default DynamicInputList;